module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm2_m_en.0d077eca8e3e96de6b3586df1eebf18f.png";